import * as allSelectors from './selectors';

export const selectors = allSelectors;
export { actions, reducer } from './duck';
